import excelIconUrl from "@/assets/icons/excel.png";
import { cn } from "@/lib/utils";

export function ExcelIcon({ className }: { className?: string }) {
  return (
    <img
      src={excelIconUrl}
      alt=""
      className={cn("object-contain", className)}
      width={40}
      height={40}
      decoding="async"
      draggable={false}
    />
  );
}
